import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'

const GenderFilter = ({ gender, setGender }) => {
  const genderOptions = [
    {
      value: 'MALE',
      label: 'Male',
    },
    {
      value: 'FEMALE',
      label: 'Female',
    },
    {
      value: 'TRANSGENDER',
      label: 'Transgender',
    },
    {
      value: 'INTERSEX',
      label: 'Intersex',
    },
    {
      value: 'NON_BINARY',
      label: 'Non Binary',
    },
    {
      value: 'PREFER_NOT_TO_SAY',
      label: 'Prefer not to say',
    },
    {
      value: 'OTHER',
      label: 'Other',
    },
  ]

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={gender}
        options={genderOptions}
        onChange={values => setGender([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default GenderFilter
